import {createAction} from 'redux-actions';
import AppTypes from '~/constants/types/AppTypes';

export const mounted = createAction(AppTypes.MOUNTED);
